function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8 1.53333H9.2C6.98819 1.53333 5.48359 1.53659 4.35686 1.68807C3.27425 1.83363 2.77281 2.09026 2.43154 2.43154C2.09026 2.77281 1.83363 3.27425 1.68807 4.35686C1.53659 5.48359 1.53333 6.98819 1.53333 9.2V13.8C1.53333 16.0118 1.53659 17.5164 1.68807 18.6431C1.83363 19.7258 2.09026 20.2272 2.43154 20.5685C2.77281 20.9097 3.27425 21.1664 4.35686 21.3119C5.48359 21.4634 6.98819 21.4667 9.2 21.4667H13.8C16.0118 21.4667 17.5164 21.4634 18.6431 21.3119C19.7258 21.1664 20.2272 20.9097 20.5685 20.5685C20.9097 20.2272 21.1664 19.7258 21.3119 18.6431C21.4634 17.5164 21.4667 16.0118 21.4667 13.8V9.2C21.4667 6.98819 21.4634 5.48359 21.3119 4.35686C21.1664 3.27425 20.9097 2.77281 20.5685 2.43154C20.2272 2.09026 19.7258 1.83363 18.6431 1.68807C17.5164 1.53659 16.0118 1.53333 13.8 1.53333ZM1.34731 1.34731C0 2.69462 0 4.86308 0 9.2V13.8C0 18.1369 0 20.3054 1.34731 21.6527C2.69462 23 4.86308 23 9.2 23H13.8C18.1369 23 20.3054 23 21.6527 21.6527C23 20.3054 23 18.1369 23 13.8V9.2C23 4.86308 23 2.69462 21.6527 1.34731C20.3054 0 18.1369 0 13.8 0H9.2C4.86308 0 2.69462 0 1.34731 1.34731Z",
  fill: "#B7B0FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 9.2C0 4.86308 0 2.69462 1.34731 1.34731C2.69462 0 4.86308 0 9.2 0H13.8C18.1369 0 20.3054 0 21.6527 1.34731C23 2.69462 23 4.86308 23 9.2V13.8C23 18.1369 23 20.3054 21.6527 21.6527C20.3054 23 18.1369 23 13.8 23H9.2C4.86308 23 2.69462 23 1.34731 21.6527C0 20.3054 0 18.1369 0 13.8V9.2Z",
  fill: "#6F62FF",
  fillOpacity: 0.1
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  width: 6.13333,
  height: 6.13333,
  rx: 3.06667,
  transform: "matrix(-1 0 0 1 16.8662 5.3667)",
  fill: "#B7B0FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  width: 4.6,
  height: 4.6,
  rx: 2.3,
  transform: "matrix(-1 0 0 1 10.7334 10.7334)",
  fill: "#B7B0FF"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  width: 3.06667,
  height: 3.06667,
  rx: 1.53333,
  transform: "matrix(-1 0 0 1 15.333 14.5669)",
  fill: "#B7B0FF"
});

var SvgEarn = function SvgEarn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEarn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/earn.198535f0.svg";
export { ForwardRef as ReactComponent };